/* Single source of truth for which app routes work offline.
 *
 * Drives:
 *   - Sidebar / BottomNav: greys out items not in this set when offline.
 *   - DashboardLayout: replaces <Outlet /> with <OfflineUnavailable /> when
 *     the user navigates (or is deep-linked) to a route outside this set
 *     while offline.
 *
 * Keep in lock-step with the snapshot shape produced by
 * backend/routes_offline.py + the read mappings in src/lib/offline-cache.js.
 * Adding a route here without backing it with cache means a blank screen,
 * not graceful offline.
 */
export const OFFLINE_AVAILABLE_PATHS = new Set([
  "/calendar", // snapshot.calendar.items
  "/expenses", // snapshot.trip_expenses (aggregated)
  "/cbp", // snapshot.cbp_airports
  "/hours-of-operation", // snapshot.aip_mx_airports + faa_nasr_airports
]);

/** True when the current pathname has an offline-cached read path.
 *  Treats `/calendar/...` as available too, so deep-link sub-routes don't
 *  fall off — extend as needed. */
export function isPathOfflineAvailable(pathname) {
  if (!pathname) return false;
  if (OFFLINE_AVAILABLE_PATHS.has(pathname)) return true;
  // Match prefixes for nested routes: /calendar/2026-05 etc.
  for (const p of OFFLINE_AVAILABLE_PATHS) {
    if (pathname.startsWith(p + "/")) return true;
  }
  return false;
}
